import AirDatepicker from 'air-datepicker'
import localeEn from 'air-datepicker/locale/en'

import Site from 'stores/Site'
import Component from 'classes/Component'
import Select from 'components/Select'

export default class Book extends Component {
    constructor({el, isDrawer = false}) {
        super()

        this.el = el
        this.isDrawer = isDrawer
        this.baseURL = 'https://stay.oudewerf.co.za/'
        this.inputs = {}

        this.initForm()
        this.initBar()
    }

    initForm() {
        this.initDates()
        this.initRooms()
        this.initCodes()
        this.initBtn()
    }

    initBtn() {
        const btn = this.el.querySelector('.b-book-btn')
        const handler = () => {
            const url = new URL(this.baseURL)
            url.searchParams.set('chain', '7717')
            url.searchParams.set('hotel', '10045')
            url.searchParams.set('currency', 'ZAR')
            url.searchParams.set('level', 'hotel')
            url.searchParams.set('locale', 'en-GB')
            url.searchParams.set('productcurrency', 'ZAR')

            let code, codeType

            Object.entries(this.inputs).forEach(([slug, input]) => {
                if (slug === 'code') {
                    code = input.value
                } else if (slug === 'promo' || slug === 'group') {
                    if (input.checked) {
                        codeType = slug
                    }
                } else if (slug === 'codeType') {
                    codeType = input.value
                } else {
                    url.searchParams.set(slug, input.value)
                }
            })

            if (code !== '') {
                url.searchParams.set(codeType, code)
            }

            window.open(url.toString(), '_blank')
        }

        this.addEventHandler({
            el: btn,
            event: 'click',
            handler
        })
    }

    initDates() {
        this.datePickers = []
        this.pickerMap = new Map()
        const dates = this.el.querySelectorAll('.b-field-date')
        let active = null

        if (this.isDrawer) {
            dates.forEach(el => {
                const btn = el.querySelector('.b-btn')

                const handler = () => {
                    if (active) {
                        active.classList.remove('active')
                        active.querySelector('.b-btn').setAttribute('aria-expanded', 'false')
                    }

                    if (active === el) {
                        active = null
                    } else {
                        active = el
                        active.classList.add('active')
                        btn.setAttribute('aria-expanded', 'true')

                        const dp = this.pickerMap.get(el)
                        if (dp) {
                            const focusStart = dp.selectedDates[0] || new Date()
                            dp.setFocusDate(focusStart)
                            dp.setViewDate(focusStart)
                            if (dp.$datepicker) dp.$datepicker.focus()
                        }
                    }
                }

                this.addEventHandler({
                    el: btn,
                    event: 'click',
                    handler
                })
            })

            const docHandler = (e) => {
                const target = e.target

                if (active && !active.contains(target)) {
                    active.querySelector('.b-btn').setAttribute('aria-expanded', 'false')
                    active.classList.remove('active')
                    active = null
                }
            }

            this.addEventHandler({
                el: document,
                event: 'click',
                handler: docHandler
            })

            this.addEventHandler({
                el: document,
                event: 'keydown',
                handler: (e) => {
                    if (e.key === 'Escape' && active) {
                        const btn = active.querySelector('.b-btn')
                        btn.setAttribute('aria-expanded', 'false')
                        active.classList.remove('active')
                        active = null
                        btn.focus()
                    }
                }
            })
        }

        dates.forEach(el => {
            const id = el.getAttribute('data-id')
            const input = el.querySelector('.b-input')
            const text = el.querySelector('.b-btn-value')
            const date = new Date()
            this.arrivePicker = null
            this.departPicker = null

            if (id === 'depart') {
                date.setDate(date.getDate() + 1)
            }

            const datePicker = new AirDatepicker(el.querySelector('.b-date'), {
                id,
                locale: localeEn,
                dateFormat: 'yyyy-MM-dd',
                minDate: date,
                onSelect: ({date, formattedDate, datepicker}) => {
                    input.value = formattedDate

                    const d = new Date(formattedDate)

                    text.textContent = d.toLocaleDateString('en-GB', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric'
                    })

                    el.classList.remove('active')
                    const btn = el.querySelector('.b-btn')
                    if (btn) btn.setAttribute('aria-expanded', 'false')

                    if (id === 'arrive' && this.departPicker) {
                        const newDate = new Date(date)
                        newDate.setDate(newDate.getDate() + 1)

                        this.departPicker.update({
                            minDate: newDate
                        })

                        this.departPicker.selectDate(newDate)
                    }
                }
            })

            if (datePicker.$datepicker) {
                const calEl = datePicker.$datepicker
                const label = id === 'arrive' ? 'Check-in date calendar' : 'Check-out date calendar'
                calEl.setAttribute('tabindex', '0')
                calEl.setAttribute('role', 'application')
                calEl.setAttribute('aria-label', label)

                const arrowDeltas = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }

                calEl.addEventListener('keydown', (e) => {
                    const current = datePicker.focusDate || datePicker.selectedDates[0] || new Date()

                    if (arrowDeltas[e.key] !== undefined) {
                        e.preventDefault()
                        const next = new Date(current)
                        next.setDate(next.getDate() + arrowDeltas[e.key])
                        datePicker.setFocusDate(next)
                        datePicker.setViewDate(next)
                    } else if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault()
                        if (datePicker.focusDate) {
                            datePicker.selectDate(datePicker.focusDate)
                            el.querySelector('.b-btn').focus()
                        }
                    }
                })
            }

            this.pickerMap.set(el, datePicker)

            if (id === 'depart') {
                this.departPicker = datePicker
            } else {
                this.arrivePicker = datePicker
            }

            this.inputs[id] = input
            this.datePickers.push(datePicker)
        })


    }

    initRooms() {
        const wrapper = this.el.querySelector('.b-field-rooms')
        const text = wrapper.querySelector('.b-btn-value')
        const roomEls = wrapper.querySelectorAll('.b-room')
        const adultInput = wrapper.querySelector('.b-input[name="adult"]')
        const childInput = wrapper.querySelector('.b-input[name="child"]')
        const roomsInput = wrapper.querySelector('.b-input[name="rooms"]')
        const addBtn = wrapper.querySelector('.b-room-btn-add')
        const removeBtn = wrapper.querySelector('.b-room-btn-remove')
        const rooms = []
        let active = 0

        this.inputs.rooms = roomsInput
        this.inputs.adult = adultInput
        this.inputs.child = childInput

        roomEls.forEach(el => {
            rooms.push({
                el,
                adult: 1,
                active: false
            })
        })

        rooms[0].el.classList.add('active')
        rooms[0].active = true

        const update = () => {
            if (!this.isDrawer) {
                if (active > 0) {
                    text.textContent = `${active + 1} Rooms`
                } else {
                    text.textContent = `${rooms[0].adult} Adults`
                }
            }

            this.inputs.rooms.value = active + 1
            const adultVals = []
            const childVals = []

            for(let i = 0; i <= active; i++) {
                adultVals.push(rooms[i].adult)
                childVals.push(0)
            }

            this.inputs.adult.value = adultVals.join('|')
            this.inputs.child.value = childVals.join('|')
        }

        roomEls.forEach((el, i) => {
            const adultBtns = el.querySelectorAll('.b-guests-adult .b-guest-select-btn')
            const adultAdd = el.querySelector('.b-guests-adult .add')
            const adultRemove = el.querySelector('.b-guests-adult .remove')
            const adultAmount = el.querySelector('.b-guests-adult .b-guests-amount')
            let adultVal = 1
            // Mirrors the SynXis config for this property (maxQuantityPerRoom,
            // adultMaxQuantity). Anything above these is silently discarded by
            // the booking engine.
            const adultLimit = 2

            const handleDisabled = () => {
                if (adultVal >= adultLimit) {
                    adultAdd.classList.add('disabled')
                } else {
                    adultAdd.classList.remove('disabled')
                }

                if (adultVal === 1) {
                    adultRemove.classList.add('disabled')
                } else {
                    adultRemove.classList.remove('disabled')
                }
            }

            const updateRoom = (i) => {
                rooms[i].adult = adultVal

                update()
            }

            adultBtns.forEach(el => {
                const handler = () => {
                    if (el.classList.contains('add')) {
                        if (adultVal >= adultLimit) return

                        adultVal++
                    } else {
                        if (adultVal === 1) return

                        adultVal--
                    }

                    adultAmount.textContent = adultVal
                    handleDisabled()
                    updateRoom(i)
                }

                this.addEventHandler({
                    el,
                    event: 'click',
                    handler
                })
            })

            handleDisabled()
        })

        const addHandler = () => {
            if (active < 2) {
                active++
            }

            if (active > 0) {
                removeBtn.classList.add('active')
            }

            if (active === 2) {
                addBtn.classList.remove('active')
            } else {
                addBtn.classList.add('active')
            }

            rooms[active].active = true
            rooms[active].el.classList.add('active')

            update()
        }

        const removeHandler = () => {
            if (active > 0) {
                active--
            }

            if (active < 2) {
                addBtn.classList.add('active')
            }

            if (active === 0) {
                removeBtn.classList.remove('active')
            } else {
                removeBtn.classList.add('active')
            }

            rooms[active + 1].active = false
            rooms[active + 1].el.classList.remove('active')

            update()
        }

        this.addEventHandler({
            el: addBtn,
            event: 'click',
            handler: addHandler
        })

        this.addEventHandler({
            el: removeBtn,
            event: 'click',
            handler: removeHandler
        })
    }

    initCodes() {
        const wrapper = this.el.querySelector('.b-field-code')
        const codeParent = wrapper.querySelector('.b-code')
        const code = wrapper.querySelector('.b-input[name="code"]')
        const text = wrapper.querySelector('.b-btn-value')
        let typeVal = 'Promo'

        if (this.isDrawer) {
            const codeType = wrapper.querySelector('.b-input[name="code-type"]')
            const select = new Select({
                el: codeType
            })
            select.init()

            this.inputs.codeType = codeType
        } else {
            const types = wrapper.querySelectorAll('.b-input[name="code-type"]')

            types.forEach(el => {
                const radioChangeHandler = () => {
                    if (el.checked) {
                        typeVal = el.getAttribute('data-id')
                    }

                    if (code.value !== '') {
                        text.textContent = typeVal + ': ' + code.value
                    }
                }

                this.addEventHandler({
                    el,
                    event: 'change',
                    handler: radioChangeHandler
                })
            })

            this.inputs.promo = types[0]
            this.inputs.group = types[1]
        }

        const changeHandler = () => {
            if (code.value) {
                codeParent.classList.add('has-value')
            } else {
                codeParent.classList.remove('has-value')
            }

            if (this.isDrawer) return

            if (code.value !== '') {
                if (text) {
                    text.textContent = typeVal + ': ' + code.value
                }
            } else {
                if (text) {
                    text.textContent = 'Select'
                }
            }
        }

        const focusHandler = (e) => {
            codeParent.classList.add('has-value')
        }

        this.addEventHandler({
            el: code,
            event: 'change',
            handler: changeHandler
        })

        this.addEventHandler({
            el: code,
            event: 'blur',
            handler: changeHandler
        })

        this.addEventHandler({
            el: code,
            event: 'focus',
            handler: focusHandler
        })

        this.inputs.code = code

    }

    initBar() {
        if (Site.isMobile || this.isDrawer) return

        let active = null

        const closeActive = () => {
            active.querySelector('.b-btn').setAttribute('aria-expanded', 'false')
            active.classList.remove('active')
            active = null
        }

        const els = this.el.querySelectorAll('.b-field')
        els.forEach(el => {
            const btn = el.querySelector('.b-btn')
            const isDateField = el.classList.contains('b-field-date')

            const handler = () => {
                if (active) closeActive()

                if (active === el) {
                    active = null
                } else {
                    active = el
                    active.classList.add('active')
                    btn.setAttribute('aria-expanded', 'true')

                    if (isDateField && this.pickerMap) {
                        const dp = this.pickerMap.get(el)
                        if (dp) {
                            const focusStart = dp.selectedDates[0] || new Date()
                            dp.setFocusDate(focusStart)
                            dp.setViewDate(focusStart)
                            if (dp.$datepicker) dp.$datepicker.focus()
                        }
                    }
                }
            }

            this.addEventHandler({
                el: btn,
                event: 'click',
                handler
            })
        })

        const docHandler = (e) => {
            if (active && !active.contains(e.target)) closeActive()
        }

        this.addEventHandler({
            el: document,
            event: 'click',
            handler: docHandler
        })

        this.addEventHandler({
            el: document,
            event: 'keydown',
            handler: (e) => {
                if (e.key === 'Escape' && active) {
                    const btn = active.querySelector('.b-btn')
                    closeActive()
                    btn.focus()
                }
            }
        })

        // if (Site.pageId === 'home') {
        //     this.barScrollHandler = () => {
        //         if (active) closeActive()
        //     }
        //
        //     Site.emitter.on('scrolled', this.barScrollHandler)
        // }
    }

    init() {
        super.init()
    }

    pageLoaded() {
        super.pageLoaded()
    }

    update() {
        super.update()
    }

    resize() {
        super.resize()
    }

    destroy() {
        super.destroy()

        this.datePickers?.forEach(picker => {
            picker.destroy()
        })

        this.barScrollHandler && Site.emitter.off('scrolled', this.barScrollHandler)
    }
}